module.exports = __webpack_public_path__ + "assets/img/index-banner2-1.3f8dd7b1.jpg";